var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotsVerticalBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 10.832C10.4615 10.832 10.8346 10.4589 10.8346 9.9987C10.8346 9.53846 10.4615 9.16536 10.0013 9.16536C9.54106 9.16536 9.16797 9.53846 9.16797 9.9987C9.16797 10.4589 9.54106 10.832 10.0013 10.832Z",
    stroke: "#B5B5B5",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 4.9987C10.4615 4.9987 10.8346 4.6256 10.8346 4.16536C10.8346 3.70513 10.4615 3.33203 10.0013 3.33203C9.54106 3.33203 9.16797 3.70513 9.16797 4.16536C9.16797 4.6256 9.54106 4.9987 10.0013 4.9987Z",
    stroke: "#B5B5B5",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 16.6654C10.4615 16.6654 10.8346 16.2923 10.8346 15.832C10.8346 15.3718 10.4615 14.9987 10.0013 14.9987C9.54106 14.9987 9.16797 15.3718 9.16797 15.832C9.16797 16.2923 9.54106 16.6654 10.0013 16.6654Z",
    stroke: "#B5B5B5",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsVerticalBlack);
export default __webpack_public_path__ + "static/media/dots-vertical_black.6c9866cec3fb4fdab098cca07add6ca8.svg";
export { ForwardRef as ReactComponent };